const userModel = {
  userId: null
};

export default userModel;
